















import { Component, Vue, Prop } from 'vue-property-decorator';
import { mdiImageOff } from '@mdi/js';

@Component
export default class NoImage extends Vue {

  @Prop({ type: [String, Number], default: undefined }) private aspectRatio!: string;
  
  @Prop({ type: String, default: '100%' }) private height!: string;
  
  @Prop({ type: String, default: '100%' }) private width!: string;
  
  @Prop({ type: String, default: undefined }) private maxHeight!: string;
  
  @Prop({ type: String, default: undefined }) private maxWidth!: string;

  private icon = mdiImageOff;

}
